// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentSummary_title__DdnM8 {
  margin: 0;
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: #404040;
  margin-bottom: 20px;
}

.PaymentSummary_paymentDetails__CzhCh {
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-top-width: 3px;
  border-right-width: 3px;
  border-bottom-width: 6px;
  border-left-width: 3px;
  border-radius: 20px;
  padding: 20px;
  border-style: solid;
  border-color: #e6e6e6;
  box-shadow: 0px 4px 8px 0px #0000000a;
}

.PaymentSummary_paymentSummary__YgGiP {
  background-color: #ffffff;
  width: 267px;
}

.PaymentSummary_detailRow__yzSKM {
  display: flex;
  flex-direction: column;
}

.PaymentSummary_detailTitle__NpEsN {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.04em;
  color: #999999;
  margin-bottom: 2px;
}

.PaymentSummary_valueRow__8wBKh {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.PaymentSummary_detailValue__iLx3G {
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: #404040;
}

.PaymentSummary_duration__vDqLv {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.04em;
  color: #999999;
}

.PaymentSummary_subscriptionNote__EENpc {
  font-family: Inter;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.04em;
  color: #999999;
  margin-top: 4px;
}

.PaymentSummary_lockIcon__jyZSY {
  width: 12px;
  height: 12px;
}
.PaymentSummary_securedInfo__ZYHC3 {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 7px;
}
.PaymentSummary_securedInfoText__5rMMT {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.04em;
  color: #999999;
  margin: 0;
}
.PaymentSummary_securedInfoContainer__C-g4c{
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
}

.PaymentSummary_link__lIs4P {
  color: #6699FF;
  text-decoration: none;
}

.PaymentSummary_link__lIs4P:hover {
  color: #6699FF;
  text-decoration: underline;
}

.PaymentSummary_proceedButtonContainer__I9Wik {
  display: block;
  margin-top: 12px;
  min-width: 200px;
}

@media (max-width: 480px) {
  .PaymentSummary_paymentSummary__YgGiP {
    width: 100%;
  }
  .PaymentSummary_paymentDetails__CzhCh {
    border: none;
    padding: 0;
    box-shadow: none;
  }
  
  .PaymentSummary_securedInfoContainer__C-g4c{
    display: none;
  }

  .PaymentSummary_securedInfoText__5rMMT{
    font-size: 10px;
    line-height: 14px;
  }

  .PaymentSummary_proceedButtonContainer__I9Wik{
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/PaymentSummary/index.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".title {\n  margin: 0;\n  font-family: Inter;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: -0.04em;\n  color: #404040;\n  margin-bottom: 20px;\n}\n\n.paymentDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  border-top-width: 3px;\n  border-right-width: 3px;\n  border-bottom-width: 6px;\n  border-left-width: 3px;\n  border-radius: 20px;\n  padding: 20px;\n  border-style: solid;\n  border-color: #e6e6e6;\n  box-shadow: 0px 4px 8px 0px #0000000a;\n}\n\n.paymentSummary {\n  background-color: #ffffff;\n  width: 267px;\n}\n\n.detailRow {\n  display: flex;\n  flex-direction: column;\n}\n\n.detailTitle {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: -0.04em;\n  color: #999999;\n  margin-bottom: 2px;\n}\n\n.valueRow {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.detailValue {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.04em;\n  color: #404040;\n}\n\n.duration {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: -0.04em;\n  color: #999999;\n}\n\n.subscriptionNote {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: -0.04em;\n  color: #999999;\n  margin-top: 4px;\n}\n\n.lockIcon {\n  width: 12px;\n  height: 12px;\n}\n.securedInfo {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 7px;\n}\n.securedInfoText {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: -0.04em;\n  color: #999999;\n  margin: 0;\n}\n.securedInfoContainer{\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 12px;\n}\n\n.link {\n  color: #6699FF;\n  text-decoration: none;\n}\n\n.link:hover {\n  color: #6699FF;\n  text-decoration: underline;\n}\n\n.proceedButtonContainer {\n  display: block;\n  margin-top: 12px;\n  min-width: 200px;\n}\n\n@media (max-width: 480px) {\n  .paymentSummary {\n    width: 100%;\n  }\n  .paymentDetails {\n    border: none;\n    padding: 0;\n    box-shadow: none;\n  }\n  \n  .securedInfoContainer{\n    display: none;\n  }\n\n  .securedInfoText{\n    font-size: 10px;\n    line-height: 14px;\n  }\n\n  .proceedButtonContainer{\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `PaymentSummary_title__DdnM8`,
	"paymentDetails": `PaymentSummary_paymentDetails__CzhCh`,
	"paymentSummary": `PaymentSummary_paymentSummary__YgGiP`,
	"detailRow": `PaymentSummary_detailRow__yzSKM`,
	"detailTitle": `PaymentSummary_detailTitle__NpEsN`,
	"valueRow": `PaymentSummary_valueRow__8wBKh`,
	"detailValue": `PaymentSummary_detailValue__iLx3G`,
	"duration": `PaymentSummary_duration__vDqLv`,
	"subscriptionNote": `PaymentSummary_subscriptionNote__EENpc`,
	"lockIcon": `PaymentSummary_lockIcon__jyZSY`,
	"securedInfo": `PaymentSummary_securedInfo__ZYHC3`,
	"securedInfoText": `PaymentSummary_securedInfoText__5rMMT`,
	"securedInfoContainer": `PaymentSummary_securedInfoContainer__C-g4c`,
	"link": `PaymentSummary_link__lIs4P`,
	"proceedButtonContainer": `PaymentSummary_proceedButtonContainer__I9Wik`
};
export default ___CSS_LOADER_EXPORT___;
